"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../core/table"));
var _editableField = _interopRequireDefault(require("../../core/editable-field"));
var _editableSelect = _interopRequireDefault(require("../../core/editable-select"));
var _button = _interopRequireDefault(require("../../core/button"));
var _link = _interopRequireDefault(require("../../core/link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Location"), /*#__PURE__*/_react.default.createElement("th", null, "Abbreviation"), /*#__PURE__*/_react.default.createElement("th", null, "Web Slug"), /*#__PURE__*/_react.default.createElement("th", null, "Latitude"), /*#__PURE__*/_react.default.createElement("th", null, "Longitude"), /*#__PURE__*/_react.default.createElement("th", null, "Post Code"), /*#__PURE__*/_react.default.createElement("th", null, "OS Map"), /*#__PURE__*/_react.default.createElement("th", null, "Grid Reference"), /*#__PURE__*/_react.default.createElement("th", null, "what3words"), /*#__PURE__*/_react.default.createElement("th", null, "County"), /*#__PURE__*/_react.default.createElement("th", null, "Used this Year"), /*#__PURE__*/_react.default.createElement("th", null)));
class SitesTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getUsage", siteID => {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-unstyled"
      }, this.props.competitions.filter(comp => comp.siteID === siteID).map(comp => /*#__PURE__*/_react.default.createElement("li", {
        key: comp.id
      }, /*#__PURE__*/_react.default.createElement(_link.default, {
        to: '/year/' + comp.yearID + '/competition/' + comp.competitionSlug + '/set-up'
      }, comp.competitionName))));
    });
  }
  render() {
    const sites = this.props.sites;
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, sites.map(site => /*#__PURE__*/_react.default.createElement("tr", {
      key: site.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "location",
      value: site.location,
      onChange: this.props.onUpdate.bind(this, site.id),
      maxLength: 100
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "abbreviation",
      value: site.abbreviation,
      onChange: this.props.onUpdate.bind(this, site.id),
      maxLength: 15
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "webSlug",
      value: site.webSlug,
      onChange: this.props.onUpdate.bind(this, site.id),
      maxLength: 100
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "number",
      enabled: true,
      name: "longitude",
      value: site.longitude,
      onChange: this.props.onUpdate.bind(this, site.id),
      maxLength: 25
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "number",
      enabled: true,
      name: "latitude",
      value: site.latitude,
      onChange: this.props.onUpdate.bind(this, site.id),
      maxLength: 25
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "postCode",
      value: site.postCode,
      onChange: this.props.onUpdate.bind(this, site.id),
      maxLength: 10
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "mapReference",
      value: site.mapReference,
      onChange: this.props.onUpdate.bind(this, site.id)
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "gridReference",
      value: site.gridReference,
      onChange: this.props.onUpdate.bind(this, site.id)
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "what3words",
      value: site.what3words,
      onChange: this.props.onUpdate.bind(this, site.id)
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableSelect.default, {
      lookup: "Counties",
      enabled: "true",
      value: site.countyID,
      name: "countyID",
      onChange: this.props.onUpdate.bind(this, site.id),
      clearable: true
    })), /*#__PURE__*/_react.default.createElement("td", null, this._getUsage(site.id)), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: () => this.props.onUpdate(site.id, true, 'isExpired')
    }, "Mark as Expired"))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(SitesTable, "partialQueries", {
  Sites: {
    id: true,
    location: true,
    webSlug: true,
    abbreviation: true,
    postCode: true,
    mapReference: true,
    gridReference: true,
    latitude: true,
    longitude: true,
    what3words: true,
    countyID: true,
    isExpired: true
  },
  Competitions: {
    id: true,
    yearID: true,
    competitionName: true,
    siteID: true,
    competitionSlug: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(SitesTable, undefined, (client, props) => ({
  onUpdate(id, value, field) {
    return client.update('Site.set', {
      id,
      field,
      value
    });
  }
}));